import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { App } from '@/app/App'
import 'flatpickr/dist/flatpickr.min.css'
import '@/styles/globals.css'
import '@/styles/components/form-field.scss'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)

// 主題在 render 前就決定，避免先閃 light 再切 dark（判斷同舊版 components/Account.jsx）
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
document.body.dataset.theme = typeof localStorage.theme === 'string' ? localStorage.theme : prefersDark ? 'dark' : 'light'

window.addEventListener('unhandledrejection', (e) => {
  console.error('[Unhandled Rejection]', e.reason)
})

// 程式檔載不到（部署新版後舊檔名已不存在、網路瞬斷）：整頁重載一次換成新版；只在 build 版觸發。
// 10 秒內不重複，避免伺服器真的掛掉時無限重整；離線時等恢復連線再重載
const CHUNK_RELOAD_KEY = 'crm:chunk-reload-at'
window.addEventListener('vite:preloadError', () => {
  if (Date.now() - Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) < 10_000) return
  const reload = () => {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
    window.location.reload()
  }
  if (navigator.onLine) reload()
  else window.addEventListener('online', reload, { once: true })
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
